import { Document } from './Document'

export class NewDocument extends Document {
  override get text(): string | undefined {
    return undefined
  }
  override async updateText(text: string) {}
  override error(): Error | undefined {
    return undefined
  }
  override async reloadContent() {}
}
